import dynamic from 'next/dynamic';
import JA from '../teaser_jp/components/A';
import JB from '../teaser_jp/components/B';
import A from './components/A';
import A_AU from './components/A_AU';
import css from './index.module.scss';
import { STAGES } from '@/constants/delta2max';
import { useGlobal } from '@/utils/useGlobal';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });
const Dynamic_AU = dynamic(() => import('./indexDynamic_AU'), { ssr: true });

export default function Teaser({ stage = STAGES.TEASER, needEmail }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <div className={`delta-2-max-teaser ${css.d2xTeaser}`}>
            {['jp', 'cn'].includes(locale) ? (
                needEmail ? (
                    <>
                        <JA stage={needEmail ? STAGES.CROWDFUNDING : stage} />
                        <JB />
                    </>
                ) : (
                    <JA stage={stage} />
                )
            ) : (
                <> {locale === 'au' ? <A_AU stage={stage} /> : <A stage={stage} />}</>
            )}
            {locale === 'au' ? <Dynamic_AU stage={needEmail ? STAGES.CROWDFUNDING : stage} /> : <Dynamic stage={needEmail ? STAGES.CROWDFUNDING : stage} />}
        </div>
    );
}
